export enum MethodsPay {
    CARD     = "CARD",
    CASH     = "CASH",
    TRANSFER = "TRANSFER",
}